export default __webpack_public_path__ + "static/media/scan.a509beb8.svg";